import React from "react";
import { Typography, Container, makeStyles, Grid } from "@material-ui/core";
import LearnerStory from "./LearnerStory";
import Stories from "./learnerStoryData.js";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    marginTop: "7.4rem",
  },

  cardList: {
    marginTop: "6.625rem",
    [theme.breakpoints.only("xs")]: {
      marginTop: "3.625rem",
    },
  },
}));

const LearnerStories = () => {
  const classes = useStyles();
  return (
    <Container maxWidth="lg" className={classes.root}>
      <Typography variant="h1" color="primary">
        Stories From Our Learners
      </Typography>
      <Container className={classes.cardList}>
        <Grid container spacing={5}>
          {Stories.map((story, i) => (
            <Grid item md={4} xs={12} key={i}>
              <LearnerStory
                time={story.time}
                msg={story.msg}
                name={story.name}
                job={story.job}
                avatar={story.avatar}
                colorStory={i % 2 === 0 ? "#EEF2F4" : "white"}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Container>
  );
};

export default LearnerStories;
